import { make } from "vuex-pathify";

// properties
const state = {
  team: {},
};

const mutations = {
  ...make.mutations(state),
};

const getters = {
  ...make.getters(state),
};

const actions = {};

export default {
  firestorePath: "teams/{teamId}",
  firestoreRefType: "doc",
  moduleName: "team",
  statePropName: "team",
  sync: {
    defaultValues: {
      status: "published",
      version: 1,
      counts: {
        total: 0,
        done: 0,
      },
      updated_at: new Date(), // need updated at by default
    },
  },
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
